import { render } from "./CheckBoxButton.vue?vue&type=template&id=6ae808b2&scoped=true"
import script from "./CheckBoxButton.vue?vue&type=script&lang=js"
export * from "./CheckBoxButton.vue?vue&type=script&lang=js"

import "./CheckBoxButton.vue?vue&type=style&index=0&id=6ae808b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae808b2"]])

export default __exports__